import React from "react";
import { useSelector } from "react-redux";
import Dashbord from "./dashbord";
import UpdatePassword from "./updatePassword";

function PassworCheck() {
  const isTempPassword = useSelector((state) => state.Login.isTempPassword);

  return <div>{isTempPassword === 0 ? <Dashbord /> : <UpdatePassword />}</div>;
}

export default PassworCheck;
